module.exports = __webpack_public_path__ + "img/de-DE-add-to-apple-wallet.1fb87e3.svg";